import config from "../../config"
import RequestService from "../RequestService"

const updateMaterial = (id, params, successCallback, failureCallback) => {
  RequestService.patch(`${config.backendUrl}/materials/${id}`, { material: params }, successCallback, failureCallback)
}

export default updateMaterial;